import DashboardMessages from './DashboardMessages';

export default DashboardMessages;
